/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { message } from '$/components/Message';
import RoboneoContext from '$/pages/RoboneoContext';
import { InitLoginConfig, useOfficialStore } from '$/store/useOfficialStore';
import { isMobile } from '$/utils';
import { useCommonStore } from '@/store/useCommonStore';

import { getEnv, navigate, pageAgent } from '@/common/agents';
import { getCookieHomeUrl } from '@/common/homeVersionCookie';
import useIsClient from '@/hooks/useIsClient';

/** 初始化官网客户端能力，并在确认已有登录态后进入对应工作台首页。 */
export default function FeatureInit() {
  const isClient = useIsClient();
  const toLogin = useCommonStore((state) => state.toLogin);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);
  const init = useCommonStore((state) => state.init);
  const initialized = useCommonStore((state) => state.initialized);
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());
  const { locationName } = pageAgent.getCurrentPage() || {};

  const loadVconsole = async () => {
    if (isMobile() && process.env.NEXT_PUBLIC_ENVIRONMENT !== 'release') {
      const VConsole = await import('vconsole');
      // eslint-disable-next-line no-new, new-cap
      new VConsole.default();
    }
  };

  useEffect(() => {
    InitLoginConfig({
      toLogin: async () => {
        await toLogin();
        initUserInfo();
      },
    });
    init();
    loadVconsole();
  }, []);

  // 服务端无法读取账号 SDK 保存在客户端的登录态时，在初始化完成后补充跳转到用户选择的工作台首页。
  useEffect(() => {
    if (!initialized || !isUserLoggedIn) {
      return;
    }
    navigate({
      mode: 'url',
      url: getCookieHomeUrl(getEnv().ENV === 'development'),
      replace: true,
    });
  }, [initialized, isUserLoggedIn]);

  useEffect(() => {
    if (
      initialized
      && !isUserLoggedIn
      && locationName
      && (locationName === 'studio' || locationName === 'ai_flow')
    ) {
      message.info('RoboNeo_Web_login_check_text');
      navigate({
        mode: 'url',
        url: getEnv().ENV === 'development' ? '/--roboneo/home' : '/home',
        replace: true,
      });
    }
  }, [locationName, initialized, isUserLoggedIn]);
  if (!isClient) {
    return null;
  }
  return (
    <RoboneoContext enableVip children={null} />
  );
}
